
import {
  computed, defineComponent, reactive,
} from 'vue';
import Card from '@/core/components/UI/Card.vue';
import Icone from '@/core/components/UI/Icone.vue';
import ManualPreenchimentoInspecao from '@/models/Constantes/ManualPreenchimentoInspecao';
import { IInspecaoSecao7 } from '@/models/Entidades/IInspecao';
import CampoNumerico from '@/core/components/UI/CampoNumerico.vue';
import SelecionarData from '@/core/components/UI/SelecionarData.vue';

export default defineComponent({
  name: 'InspecaoSecao7',
  props: {
    secao7: {
      type: Object as () =>IInspecaoSecao7,
      required: true,
    },
    bloquearCampos: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    Card,
    Icone,
    CampoNumerico,
    SelecionarData,
  },
  emits: ['update:secao7', 'change'],
  setup(props, { emit }) {
    const state = reactive({
      enviandoArquivos: false,
      excluindoArquivos: false,
      manuaisPreenchimento: {} as Record<string, boolean>,
    });

    const computedSecao7 = computed({
      get: () => props.secao7,
      set: (valor: IInspecaoSecao7) => {
        emit('update:secao7', valor);
      },
    });

    function change() {
      emit('change');
    }

    function alternarManualPreenchimento(chave: string) {
      state.manuaisPreenchimento[chave] = !state.manuaisPreenchimento[chave];
    }

    return {
      props,
      computedSecao7,
      state,
      change,
      ManualPreenchimentoInspecao,
      alternarManualPreenchimento,
    };
  },
});
